module.exports = __webpack_public_path__ + "static/rollover_emergencia-b23e5eb76b048a1c51c3fcc7671e7dda.svg";